
export default (lang) => {
return `query orderAllStatusQuery($itemPath: String = "/sitecore/content/lynkco-global-portal/Global Setting/Order Status") {
  # Datasource query
  # $datasource will always be set to the ID of the rendering's datasource item
  # (as long as the GraphQLData helper is used)
 allStatus: item(path: $itemPath, language:"${lang}")
  {
    name
    children
    {
      key:field(name:"key")
      {
       value
      }
      name:field(name:"name")
      {
       value
      }
      children
      {
         key:field(name:"key")
         {
          value
         }
         name:field(name:"name")
         {
          value
         }
         icon:field(name:"icon")
         {
           ... on ImageField {
            src
            alt
          }
         }
      }
    }
  }
}`
}